import { Admin } from '@shared/socket-namespaces/admin/admin.namespace';
import { adminSocket } from '@shared/socket-namespaces/admin/admin.socket';
import { useEffect, useRef } from 'react';

export const useAdminEvent = <K extends keyof Admin.ServerEvents>(
    event: K,
    callback: Admin.ServerEvents[K],
) => {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    useEffect(() => {
        const handler = ((...args: unknown[]) => {
            (callbackRef.current as (...a: unknown[]) => void)(...args);
        }) as Parameters<typeof adminSocket.on<K>>[1];

        adminSocket.on(event, handler);

        return () => {
            adminSocket.off(event, handler);
        };
    }, [event]);
};
